import { ReactNode } from 'react';
import { LocalStorageProvider } from './data/use_local_storage.tsx';
import { AppContextProvider } from './util/app_context.tsx';
import { CurrentDateProvider } from './util/use_current_date.tsx';
import { CurrentTimeProvider } from './util/use_current_time.tsx';

// The context every page expects above the router, shared by main.tsx and the onboarding flow tests
export const AppProviders = ({ children }: { children: ReactNode }) => (
  <LocalStorageProvider>
    <CurrentDateProvider>
      <CurrentTimeProvider>
        <AppContextProvider>{children}</AppContextProvider>
      </CurrentTimeProvider>
    </CurrentDateProvider>
  </LocalStorageProvider>
);
